// import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { uiHelper } from '~/helpers/ui.helper';

declare let $;
import { translatePipe, translationHelper } from '~/helpers/translation.helper';
import { sportradarStats } from '@env/environment';

export interface DialogData {
    tournamentId: string;
    sportId: string;
    type: string;
    betradarMatchId: string;
}
declare let SIR: any;

@Component({
    selector: 'comp_standings_modal',
    templateUrl: './standings-modal.html',
})
export class StandingsModal implements OnInit, OnDestroy {
    iframe_src = this.domSanitizer.bypassSecurityTrustResourceUrl(sportradarStats + 'de/1/tournament/1');

    subsidleResetListener;
    constructor(private domSanitizer: DomSanitizer, private _uiHelper: uiHelper, public translate: translationHelper) {
        this.subsidleResetListener = this._uiHelper.idleResetListener.subscribe(s => {
            this.modalHide();
        });
    }

    ngOnInit() {}

    public ngAfterViewInit() {
        // this.iframe_src = "";
        //console.warn('comp_standings_modal');
        this._uiHelper.uniquetournament_Listener.subscribe(x => {
            // console.warn('tournamentType_Listener', x);
            if (x != 0) {
                let url = '';

                url = sportradarStats + this.translate.LANGCODE + '/uniquetournament/' + x;

                this.iframe_src = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
            }
        });

        this._uiHelper.statisticListener.subscribe(x => {
            //console.warn('statisticListener', x);
            if (x != 0) {
                let url = '';

                url = sportradarStats + this.translate.LANGCODE + '/match/' + x;
                this.iframe_src = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
            }
        });
    }

    modalHide() {
        this.iframe_src = this.domSanitizer.bypassSecurityTrustResourceUrl('about:blank');
        $('#Standings_Modal').modal('hide');
    }

    ngOnDestroy() {
        if (this.subsidleResetListener != undefined) {
            this.subsidleResetListener.unsubscribe();
            this.subsidleResetListener = undefined;
        }
    }
}
